import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView, useMotionValue, useSpring } from 'framer-motion';
import { User, Globe, MessageCircle, Sparkles, Filter, Database, Calendar, RefreshCw } from 'lucide-react';
const nodes = [{
  label: 'Visitante',
  icon: User,
  status: 'Nuevo visitante'
}, {
  label: 'Web',
  icon: Globe,
  status: 'Interacción detectada'
}, {
  label: 'WhatsApp',
  icon: MessageCircle,
  status: 'Mensaje recibido · ahora'
}, {
  label: 'IA',
  icon: Sparkles,
  status: 'Analizando intención...'
}, {
  label: 'Calificación',
  icon: Filter,
  status: 'Interés: alto'
}, {
  label: 'CRM',
  icon: Database,
  status: 'Lead actualizado ✓'
}, {
  label: 'Agenda',
  icon: Calendar,
  status: '2 horarios disponibles'
}, {
  label: 'Seguimiento',
  icon: RefreshCw,
  status: 'Automatización activa'
}];
export function SystemFlow() {
  const containerRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(containerRef, {
    amount: 0.4
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const rawRotateX = useMotionValue(0);
  const rawRotateY = useMotionValue(0);
  const rotateX = useSpring(rawRotateX, {
    stiffness: 150,
    damping: 20
  });
  const rotateY = useSpring(rawRotateY, {
    stiffness: 150,
    damping: 20
  });
  useEffect(() => {
    if (!isInView) return;
    const prefersReduced = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;
    const interval = setInterval(() => {
      setActiveIndex(i => (i + 1) % nodes.length);
    }, 1700);
    return () => clearInterval(interval);
  }, [isInView]);
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;
    rawRotateY.set(px * 8);
    rawRotateX.set(py * -8);
  };
  const handleMouseLeave = () => {
    rawRotateX.set(0);
    rawRotateY.set(0);
  };
  return <div ref={containerRef} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} style={{
    perspective: 1200
  }} className="relative w-full max-w-[360px] mx-auto" data-id="element-266" data-mp="3k03hddcbni8k">
      <motion.div style={{
      rotateX,
      rotateY
    }} className="relative flex flex-col gap-3 py-2" data-id="element-267" data-mp="3f2uwh4zsh03m">
        <div aria-hidden="true" className="absolute left-[26px] top-[24px] bottom-[24px] w-px bg-carbon/10" data-id="element-268" data-mp="30df8fwrn78rm">
          <div className="system-flow-pulse absolute left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-azul" data-id="element-269" data-mp="3568d6kn42h3p" />
        </div>

        {nodes.map((node, idx) => {
        const Icon = node.icon;
        const isActive = idx === activeIndex;
        return <motion.div key={node.label} initial={{
          opacity: 0,
          x: 16,
          rotate: 0
        }} whileInView={{
          opacity: 1,
          x: 0,
          rotate: idx % 2 === 0 ? -1 : 1
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: idx * 0.06
        }} animate={{
          scale: isActive ? 1.03 : 1,
          borderColor: isActive ? 'rgba(33,77,67,0.4)' : 'rgba(23,23,23,0.1)'
        }} className="relative z-10 flex items-center gap-3 bg-arena border rounded-[12px] pl-2.5 pr-4 py-2.5 shadow-card transition-shadow duration-300" style={{
          boxShadow: isActive ? '0 4px 20px rgba(33,77,67,0.14)' : undefined
        }} data-id="element-270" data-mp="2het5ecckf7l2" data-mpi={idx}>
              <span className={`relative flex items-center justify-center w-8 h-8 rounded-full flex-shrink-0 transition-colors duration-300 ${isActive ? 'bg-verde text-arena' : 'bg-verde/10 text-verde'}`} data-id="element-271" data-mp="30gxkdqozdecf">
                <Icon size={15} strokeWidth={2} data-id="element-272" data-mp="12qr2b82fvfep" />
                {isActive && <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-azul" data-id="element-273" data-mp="17klgjvz9z26e" />}
              </span>
              <span className="flex flex-col leading-tight" data-id="element-274" data-mp="1ck7vc9ur4qhb">
                <span className="font-body text-[13px] font-medium text-carbon" data-id="element-275" data-mp="evwo0lcac569">
                  {node.label}
                </span>
                <span className={`font-body text-[10.5px] transition-colors duration-300 ${isActive ? 'text-verde' : 'text-carbon/35'}`} data-id="element-276" data-mp="jvj2sz7rhth6">
                  {node.status}
                </span>
              </span>
            </motion.div>;
      })}
      </motion.div>
    </div>;
}